module.exports = __webpack_public_path__ + "static/media/Arrow-Circle-Close.01c07454.svg";